import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { SaveIcon } from "@heroicons/react/outline";

import { ContentWrapper } from "../../../components/ContentWrapper";
import { Breadcrumb } from "../../../components/molecules/Breadcrumb";
import { TitleM } from "../../../components/atoms/Typography";
import { Button } from "../../../components/atoms/Button";
import { Theme } from "../../../components/atoms/theme";
import Form from "../../../components/organisms/Form";
import { useCreateUserMutation } from "../../../redux/reduxQuery/usersApi";
import { useMutationWrapper } from "../../../common/api";

const crumbLinks = [
  {
    text: "Admin Settings",
    path: "/admin/settings",
  },
  {
    text: "New Admin",
  },
];

export default function CreateAdmin() {
  let navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);

  const form = useForm();

  const [createUser] = useCreateUserMutation();
  const mutate = useMutationWrapper(
    createUser,
    "Successfuly Created a New Admin",
    () => {
      setIsProcessing(false);
      navigate("/admin/settings");
    }
  );
  const onSubmit = form.handleSubmit((data) => {
    setIsProcessing(true);
    return mutate({ ...data, roles: "admin" });
  });

  const formInputs = [
    {
      id: "name",
      label: "Full Name",
      required: true,
      copy: false,
      addNew: false,
      icon: false,
    },
    {
      id: "email",
      label: "Email",
      required: true,
      copy: false,
      addNew: false,
      icon: false,
      type: "email",
    },
  ];

  return (
    <ContentWrapper>
      <div style={{ marginBottom: "1.5rem" }} />
      <Breadcrumb
        crumbs={crumbLinks}
        buttons={[
          <Button
            icon={true}
            color={Theme.colors.primaries_000}
            hoverColor={Theme.colors.primaries_neg100}
            noText={true}
            onClick={onSubmit}
            loader={isProcessing}
            buttonText="Create New Admin"
            img={
              <SaveIcon width={"1.25rem"} color={Theme.colors.neutrals_500} />
            }
          />,
        ]}
      />
      <TitleM>New Admin</TitleM>
      <Form
        {...form}
        onSubmit={onSubmit}
        formInputs={formInputs}
        numberOfColumns={1}
        submitButtonText={"Create New Admin"}
        cancelAction={() => {
          navigate(-1);
        }}
      />
    </ContentWrapper>
  );
}
